import React, { useEffect, useState } from 'react';
import { SearchIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
type Location = {
  name: string;
  address: string;
  zip: string;
  mapsUrl: string;
  featured: boolean;
};
const ALL_LOCATIONS: Location[] = [{
  name: 'Cottage City',
  address: '4014 Bladensburg Rd, Cottage City, MD 20722',
  zip: '20722',
  mapsUrl: 'https://maps.google.com/?q=4014+Bladensburg+Rd+Cottage+City+MD+20722',
  featured: false
}, {
  name: 'Capitol Heights',
  address: '1205 Marblewood Ave, Capitol Heights, MD',
  zip: '20743',
  mapsUrl: 'https://maps.google.com/?q=1205+Marblewood+Ave+Capitol+Heights+MD',
  featured: true
}, {
  name: 'Suitland',
  address: '4510 Suitland Rd, Suitland, MD',
  zip: '20746',
  mapsUrl: 'https://maps.google.com/?q=4510+Suitland+Rd+Suitland+MD',
  featured: false
}];
export function LocationSection() {
  const [zipQuery, setZipQuery] = useState('');
  const [filtered, setFiltered] = useState<Location[]>(ALL_LOCATIONS);
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const q = searchParams.get('q');
    if (q) {
      setZipQuery(q);
      const results = ALL_LOCATIONS.filter(loc => loc.name.toLowerCase().includes(q.toLowerCase()) || loc.zip.includes(q) || loc.address.toLowerCase().includes(q.toLowerCase()));
      setFiltered(results.length > 0 ? results : ALL_LOCATIONS);
    }
  }, [searchParams]);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = zipQuery.trim().toLowerCase();
    if (!q) {
      setFiltered(ALL_LOCATIONS);
      return;
    }
    const results = ALL_LOCATIONS.filter(loc => loc.name.toLowerCase().includes(q) || loc.zip.includes(q) || loc.address.toLowerCase().includes(q));
    setFiltered(results);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setZipQuery(val);
    if (!val.trim()) setFiltered(ALL_LOCATIONS);
  };
  return <section id="locations" className="w-full bg-[#F5F5F5] py-20 px-4 sm:px-6 lg:px-8" data-id="element-281">
      <div className="max-w-7xl mx-auto" data-id="element-282">
        <div className="text-center mb-10" data-id="element-283">
          <h2 className="text-3xl sm:text-4xl font-black text-black mb-3" data-id="element-284">
            Find Your Nearest Ameritech Location
          </h2>
          <p className="text-base" style={{
          color: '#616365'
        }} data-id="element-285">
            3 convenient locations across the DMV area
          </p>
        </div>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto mb-12" data-id="element-286">
          <div className="relative flex-1" data-id="element-287">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-288" />
            <input type="text" value={zipQuery} onChange={handleInputChange} placeholder="Enter your zip code or city..." className="w-full pl-10 pr-4 py-3.5 border border-gray-200 rounded bg-white text-black placeholder-gray-400 text-sm focus:outline-none focus:ring-2 focus:border-transparent" style={{
            '--tw-ring-color': '#CC0000'
          } as React.CSSProperties} aria-label="Search by zip code or city" data-id="element-289" />
          </div>
          <button type="submit" className="text-white font-bold px-8 py-3.5 rounded transition-colors duration-200 text-sm whitespace-nowrap" style={{
          background: '#CC0000'
        }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-290">
            Find Location
          </button>
        </form>

        {/* Location Cards */}
        {filtered.length === 0 ? <div className="text-center py-12" data-id="element-291">
            <p className="text-lg font-semibold text-black mb-2" data-id="element-292">
              No locations found
            </p>
            <p className="text-sm" style={{
          color: '#616365'
        }} data-id="element-293">
              Try searching by city name or zip code (20722, 20743, 20746)
            </p>
            <button onClick={() => {
          setZipQuery('');
          setFiltered(ALL_LOCATIONS);
        }} className="mt-4 font-bold text-sm transition-colors" style={{
          color: '#CC0000'
        }} data-id="element-294">
              Show all locations
            </button>
          </div> : <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-295">
            {filtered.map(loc => <div key={loc.name} className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6 flex flex-col" style={loc.featured ? {
          borderTop: '4px solid #CC0000'
        } : {}} data-id="element-296">
                <div className="flex items-start gap-3 mb-4" data-id="element-297">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
              background: 'rgba(204,0,0,0.10)'
            }} data-id="element-298">
                    <MapPinIcon size={18} style={{
                color: '#CC0000'
              }} data-id="element-299" />
                  </div>
                  <div data-id="element-300">
                    <h3 className="font-black text-black text-lg leading-tight" data-id="element-301">
                      {loc.name}
                    </h3>
                    <p className="text-sm mt-1" style={{
                color: '#616365'
              }} data-id="element-302">
                      {loc.address}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 mb-5" data-id="element-303">
                  <ClockIcon size={15} className="text-green-500" data-id="element-304" />
                  <span className="text-green-600 font-semibold text-sm" data-id="element-305">
                    Open 24 Hours
                  </span>
                </div>
                <div className="mt-auto flex gap-3" data-id="element-306">
                  <a href={loc.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex-1 text-center font-bold text-sm py-2.5 rounded transition-colors duration-200" style={{
              border: '2px solid #1A3BCC',
              color: '#1A3BCC'
            }} onMouseEnter={e => {
              e.currentTarget.style.background = '#1A3BCC';
              e.currentTarget.style.color = '#ffffff';
            }} onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#1A3BCC';
            }} data-id="element-307">
                    Get Directions
                  </a>
                  <a href="tel:3012549001" className="flex-1 text-center text-white font-bold text-sm py-2.5 rounded transition-colors duration-200" style={{
              background: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-308">
                    Call Now
                  </a>
                </div>
              </div>)}
          </div>}
      </div>
    </section>;
}